import styled from 'styled-components';

import { Icon } from 'app/theme/Icons/Icon';
import { breakpoint } from 'app/theme/theme';
import { common } from 'app/translations/dictionary';

const Container = styled.div`
  margin: 0 auto;
  text-align: center;
  font-size: 2.5rem;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  span {
    margin: 2rem 0;
  }

  ${breakpoint.up.md`
    font-size: 3.5rem;
  `}
`;

const StyledIcon = styled(Icon)`
  &&&& {
    color: ${({ theme }) => theme.palette.primary};
    font-size: 8rem;
    opacity: 0.7;
  }
`;

export const NotFound = (): JSX.Element => (
  <Container>
    <StyledIcon name="window close outline" />
    <span>{common.pageNotFound}</span>
  </Container>
);
